import React, { Component } from 'react';
import { Button, Icon, Card, Modal, Grid, Label } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import Accordion from '@zippytech/react-toolkit/Accordion'
import '@zippytech/react-toolkit/Accordion/index.css'
import DeleteUserFromUnit from './../drive/modals/DeleteUserFromUnit'
import AddUnitUsers from '../drive/AddUsers';
import ImageAvater from '../../../drive/Components/ImageAvater'
import setColor from '../../../common/SetColor';
import SingleLineEditText from '../../../common/SingleLineEditText';
import MultiLineEditText from '../../../common/MultiLineEditText';
import ShowMetadata from './ShowMetadata';

@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Team Information Cards")
})

class ResourcePane extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openModalFlag: false,
            modalFlag: false,
            schema: null,
            preMeta: {}
        }
        this.deleteSubOrg = this.deleteSubOrg.bind(this);

        this.deleteUser = this.deleteUser.bind(this);
        this.entitledToDelete = this.entitledToDelete.bind(this);
    }
    openModal() {
        dispatch.community.setAddUserContextData('Teams');
        this.setState({ openModalFlag: true })
    }
    closeModal() {
        this.setState({ openModalFlag: false })
    }

    async deleteSubOrg(subOrgdata) {
        try {
            await dispatch.organizationUnit.checkSuborganizationBeforeDelete(subOrgdata._id);
            let message = <div className="confirmMessage">
                <h3>Delete Team</h3>
                <label>{subOrgdata.name}</label>
                <p>Are you sure that you wish to delete this team?</p>
                <span >This action is not reversible</span>
            </div>
            toastr.confirm(message, {
                onOk: async () => {
                    subOrgdata.orgUniqueId = this.props.orgUniqueId;
                    subOrgdata.selectedSubOrg = this.props.selectedSubOrg;
                    await dispatch.organizationUnit.deleteSubOrganizationAsync(subOrgdata);

                }
            });

        }
        catch (err) {
            const toastrConfirmOptions = {
                disableCancel: true
            };
            toastr.confirm(err.message, toastrConfirmOptions, {
                onOk: () => {
                }
            });
        }
    }




    saveData = (data) => {
        if (data.name === 'Name') {
            let paylaod = {
                name: data.text.trim(),
                oldName: this.props.selectedSubOrg.name,
                slug: data.text.toLowerCase(),
                _id: this.props.selectedSubOrg._id,
                organizationId: this.props.selectedOrganisation.id
            }
            dispatch.organizationUnit.editSubOrganizationNameAsync(paylaod);
        } else if (data.name === 'Summary') {
            let paylaod = {
                summary: data.text.trim(),
                _id: this.props.selectedSubOrg._id
            }
            dispatch.organizationUnit.editSubOrganizationDescriptionAsync(paylaod);
        }
    }


    deleteUser(user) {
        user.type = 'deleteUserFromTeamResourcepane'
        dispatch.users.addUserToDelete(user);
        dispatch.users.userDelModalOpen(true);
    }

    entitledToDelete(user) {
        let ManagerArray = this.props.teamUsersArray.filter((item) => { return item.role === "Manager" })
        if (ManagerArray.length === 1 && user.role === "Manager") {
            return false;
        }
        return true;
    }

    // Below changes isWorkspaceOwner, isManager & setMetaDataFlag are added for KLM-8949
    isWorkspaceOwner = () => {
        // const loggdinUserId = this.props.user._id;
        let authors =
            this.props.currentOrganization &&
            this.props.currentOrganization.users &&
            this.props.currentOrganization.users.filter(
                (el) =>
                    el.accountUserId === this.props.user._id &&
                    el.role === "workspaceOwner"
            );
        if (authors && authors.length > 0) {
            return true;
        }
        return null;
    };

    isManager = () => {
        let manager =
            this.props.currentOrganization &&
            this.props.currentOrganization.users &&
            this.props.currentOrganization.users.filter(
                (el) =>
                    el.accountUserId === this.props.user._id &&
                    el.role === "Manager"
            );
        if (manager && manager.length > 0) {
            return true;
        }
        return null;
    }
    async handleClickUserDetailsPage(usersData, history, e) {
        if (this.props.selectedOrganisation.role === 'workspaceOwner') {
            let user = this.props.usersList.find((user)=>user._id === usersData.accountUserId._id)
            e.stopPropagation();
            await dispatch.users.updateState(user);
            await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            await dispatch.organizationUnit.showResourecePane(null);
            await dispatch.organizationUnit.setActivePaneIndex(null)
            let ops = "Add Sub-Team"
            dispatch.community.addBreadCrumbOps(ops);
            history.push({
                pathname: `/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_cm/userDetail/${this.props.selectedSubOrg ? this.props.selectedSubOrg._id : this.props.selectedOrganisation.id}/${user.role}/${user._id}`,
            });
        }
    }
    async onSelectionChange(subOrg) {
        console.log(subOrg)
        dispatch.app.showToolbar(true)
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        dispatch.organizationUnit.showResourecePane(null);
        dispatch.organizationUnit.setActivePaneIndex(null);
        dispatch.organizationUnit.landingPageFlagSet(false);
        dispatch.community.addMainAreaContext('ORGANIZATION');
        dispatch.organizationUnit.addSelectedSubOrg(subOrg);
        dispatch.users.storeUnitId(subOrg._id);
        const history = this.props.history;
        let query = {
          $sort: { createdAt: 1 },
          $skip: 0,
          $limit: this.props.teamsListViewFlag ? 10 : 50
        }
        if (this.props.selectedOrganisation.id === subOrg._id) {
          let payload = {
            query: query,
            organizationId: this.props.selectedOrganisation.id,
            accountId: this.props.match.params.accountId
          };
          await dispatch.organizationUnit.getAssignedSubOrgAsync(payload);
          await dispatch.organizationUnit.getOrgByIdAsync(this.props.match.params.workspaceId);
        }
        else {
          let payload = {
            query: query,
            teamId: subOrg._id
          };
          await dispatch.organizationUnit.getSubOrgByParentIdAsync(payload);
          await dispatch.organizationUnit.getSubOrgByIdAsync(subOrg._id);
        }
        history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/team/${subOrg._id}`);
        dispatch.organizationTab.getUsersTreeAsync({ id: subOrg._id, accountId: this.props.match.params.accountId });
        let payload = {
          query: query,
          organizationId: this.props.selectedOrganisation.id,
          referenceId: subOrg._id
        };
        dispatch.invite.getInvitesAsync(payload);
      }
      handleAccordionClick = async (e) => {
        if(this.props.activePaneIndex || this.props.activePaneIndex === 0){
            if(e.target.textContent.includes("Summary") && this.props.activePaneIndex !== 0){
               await dispatch.organizationUnit.setActivePaneIndex(0)
            } else if(e.target.textContent.includes("Sub-Teams") && this.props.activePaneIndex !== 1){
               await dispatch.organizationUnit.setActivePaneIndex(1)
            }else if(e.target.textContent.includes("Users") && this.props.activePaneIndex !== 2){
               await dispatch.organizationUnit.setActivePaneIndex(2)
            }else if(e.target.textContent.includes("MetaData") && this.props.activePaneIndex !== 3){
               await dispatch.organizationUnit.setActivePaneIndex(3)
            }
        }
      }
    setMetaDataFlag = async (flag) => {
        if(this.props.selectedSubOrg.metaData) {
            await this.setState({
                preMeta: this.props.selectedSubOrg.metaData
            })
        }
        await this.setState({ modalFlag: flag });
    };

    render() {
        // Below changes are made for KLM-8949
        let metaDataFlag = false

        if(this.isWorkspaceOwner() || this.isManager()) {
            metaDataFlag = true
        }

        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>


        let counts = {}

        if (this.props.subOrgsResourcePane) {
            counts.subTeamLength = <Label>{this.props.subOrgsResourcePane.data && this.props.subOrgsResourcePane.data.length}</Label>
        }
        if (this.props.teamUsersArray) {
            counts.userLength = <Label>{this.props.teamUsersArray && this.props.teamUsersArray.length}</Label>
        }

        return (
            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">

                    <Accordion expandTool={expandTool} activeIndex={this.props.activePaneIndex} horizontal enableKeyboardNavigation={false} onClick={this.handleAccordionClick}>
                        <div tabTitle="Summary">
                            <div className="acc-header">Summary</div>
                            <div className="resourcePaneOverflow">
                                <Form noValidate
                                    className="formcyForm"
                                    ref={ref => this.form = ref}
                                    onValidSubmit={this.props.onSubmit}>
                                    <Grid>
                                        <Grid.Row>
                                            <Grid.Column width={16}>
                                                <div >
                                                    <Form noValidate
                                                        className="invitationForm"
                                                        ref={ref => this.form = ref}
                                                    // onValidSubmit={this.props.onSubmit}
                                                    >
                                                        <SingleLineEditText
                                                            name="Name"
                                                            text={this.props.selectedSubOrg.name}
                                                            type="text"
                                                            onSaveClick={this.saveData}
                                                        />
                                                        <MultiLineEditText
                                                            name="Summary"
                                                            text={this.props.selectedSubOrg.summary}
                                                            type="textarea"
                                                            onSaveClick={this.saveData}
                                                            htmlView={true}
                                                        />
                                                    </Form>
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Form>
                            </div>
                        </div>
                        <div tabTitle={<div>Sub-Teams {counts.subTeamLength} </div>}>
                            <div className="acc-header">Sub-Teams {counts.subTeamLength}</div>
                            {this.props.subOrgsResourcePane &&
                                this.props.subOrgsResourcePane.data.length ?
                                this.props.subOrgsResourcePane.data.map(function (subOrg, index) {
                                    return (
                                        <div key={index} className="deleteOrgBtn">
                                            <Icon name="sitemap" disabled style={{ width: "20px", float: "left" }} />
                                            <div style={{ width: "calc(100% - 60px)", float: "left", cursor:"pointer" }} onClick={() => { this.onSelectionChange(subOrg) }}>
                                                {subOrg.name}
                                            </div>
                                            <Icon name='trash alternate' className="trash-color" onClick={() => { this.deleteSubOrg(subOrg) }} style={{ "float": "right", "cursor": "pointer", width: "30px" }} />
                                        </div>
                                    );
                                }, this) : 'No Sub-Teams to display.'}
                        </div>
                        <div tabTitle={<div>Users {counts.userLength} </div>}>
                            <div className="acc-header">Users {counts.userLength}
                                <Icon style={{ cursor: "pointer" }} name='plus' color='green' onClick={() => this.openModal()} /></div>
                            <Modal
                                open={this.state.openModalFlag}
                                size='large'
                                closeOnEscape={false}
                                closeOnDimmerClick={false}
                            >

                                <Modal.Content>
                                    <Modal.Description>
                                        {this.props.selectedSubOrg && this.props.selectedSubOrg ?
                                            <AddUnitUsers history={this.props.history} {...this.props}
                                                searchUserArr={this.props.searchUserArr}
                                                searchInviteUserArr={this.props.searchInviteUserArr}
                                                selectedOrganisation={this.props.selectedOrganisation}
                                                selectedSubOrg={this.props.selectedSubOrg}
                                                user={this.props.user}
                                                addUserContext={this.props.addUserContext}
                                                stringType="SubOrgUserAddModal"
                                                onClose={() => this.closeModal()}
                                            /> : ''}
                                    </Modal.Description>
                                </Modal.Content>

                            </Modal>


                            <Card.Group style={{ 'marginTop': '0.1em' }}>
                                {this.props.teamUsersArray && this.props.teamUsersArray.length > 0 ?
                                    this.props.teamUsersArray.map(function (usersData, index) {
                                        return (
                                            <div key={index}>
                                                <Card className="contributorCard ">
                                                    <Card.Content>
                                                        <ImageAvater user={usersData.accountUserId} />
                                                        {this.entitledToDelete(usersData) ?
                                                            <Icon
                                                                name="trash alternate"
                                                                className="trash-color"
                                                                style={{ position: "absolute", top: "3px", right: "0", 'cursor': 'pointer' }}
                                                                onClick={() => this.deleteUser(usersData)}
                                                            />
                                                            :
                                                            <Icon
                                                                name="trash alternate"
                                                                className="trash-color"
                                                                style={{ position: "absolute", top: "3px", right: "0", 'cursor': 'pointer', opacity: ".6" }}
                                                            />
                                                        }
                                                        <Card.Header style={{ 'margin': '0 17px 0 0' }} onClick={(e) => { this.handleClickUserDetailsPage(usersData, this.props.history, e) }}>{usersData.accountUserId.firstName + ' ' + usersData.accountUserId.lastName}</Card.Header>
                                                        <Card.Meta>{usersData.role} </Card.Meta>
                                                    </Card.Content>
                                                </Card>
                                            </div>
                                        );
                                    }, this) : 'No users to display.'}

                                {this.props.subOrgInvitaions && this.props.subOrgInvitaions.length ?
                                    this.props.subOrgInvitaions.map(function (invite, index) {
                                        return (
                                            <Card className="contributorCard playbookInviteBg" style={{ "cursor": 'pointer' }} key={index} >
                                                <Card.Content>
                                                    <span
                                                        onClick={this.props.onClick}
                                                        className={`avaterNameIcon`}
                                                        style={{ background: setColor(invite.firstName.charAt(0).toUpperCase()) }}>
                                                        {invite.firstName.charAt(0).toUpperCase()}
                                                        {invite.lastName.charAt(0).toUpperCase()}
                                                    </span>
                                                    <Card.Header>{invite.firstName + ' ' + invite.lastName}</Card.Header>
                                                    <Card.Meta>{invite.role + " (Invited)"}</Card.Meta>
                                                </Card.Content>
                                            </Card>
                                        );
                                    }, this)
                                    : ''}

                            </Card.Group>
                            {this.props.userDelModalOpen ?
                                <DeleteUserFromUnit
                                    selectedOrganisation={this.props.selectedOrganisation}
                                    selectedAccount={this.props.selectedAccount}
                                    userToDel={this.props.userToDel}
                                    selectedTeamName={this.props.selectedSubOrg.name}
                                    userDelModalOpen={this.props.userDelModalOpen}
                                    selectedSubOrg={this.props.selectedSubOrg}
                                    teamUsersArray={this.props.teamUsersArray}
                                    subOrgs={this.props.subOrgs}
                                />
                                : ''}
                        </div>
                        <div tabTitle="MetaData">
                            <div className="acc-header">MetaData
                                <span
                                    style={{ margin: "0 20px" }}
                                    className="clr-gray fs_italic"
                                >
                                    <Button
                                    disabled={!metaDataFlag}
                                    content="Edit"
                                    className="button-submit float-right "
                                    type="button"
                                    onClick={() => this.setMetaDataFlag(true)}
                                    />
                                </span>
                            </div>
                            <div className="resourcePaneOverflow">
                                {this.props.selectedSubOrg.metaData ? <pre>{JSON.stringify(this.props.selectedSubOrg.metaData, null, 2)}</pre> : <pre>{JSON.stringify({"N/A": "This team has no metadata."})}</pre>}
                            </div>
                        </div>
                    </Accordion>
                </div>
                <ShowMetadata
                    open={this.state.modalFlag}
                    setMetaDataFlag={this.setMetaDataFlag}
                    selectedSubOrg={this.props.selectedSubOrg}
                    preMetadata={this.state.preMeta}
                />
            </div>

        )
    }
}

export default ResourcePane;
